import { ArnLoggerFactory } from './ArnLoggerFactory';
import { ArnLogger } from './ArnLogger';
import { ConsoleLogConfig, DefaultLogger } from './DefaultLogger';
import { ArnValidLogConfig, ArnLogLevel } from '@arianee/arn-types';
import { ArnLogConfig } from './ArnLogConfig';

export const defaultConsole = console;

export const envLogLevels: ArnLogLevel[] = (
  process.env.ARN_LOG_LEVEL?.split(',') ?? [ArnLogLevel.warn, ArnLogLevel.error]
).map((s) => (ArnLogLevel as any)[s]);

export class DefaultLoggerFactory implements ArnLoggerFactory {
  create(spec?: ArnLogConfig): ArnLogger {
    const config = this.createConfig(spec);
    const consoleConfig: ConsoleLogConfig = {
      ...config,
      console: defaultConsole,
    };
    return new DefaultLogger(consoleConfig);
  }

  createConfig(spec?: ArnLogConfig): ArnValidLogConfig {
    return {
      name: spec?.name || 'arn',
      logLevels: spec?.logLevels || envLogLevels,
    };
  }
}
